import { FINANCIAL_ACCOUNT_TYPE_LABEL } from "@common/constants";
import { AccountClassMismatch } from "./getAccountClassMismatches";

const CLASS_COPY = {
    liabilityToAsset: {
        imported: "a liability",
        target: "an asset",
        movement: "from liabilities to assets",
    },
    assetToLiability: {
        imported: "an asset",
        target: "a liability",
        movement: "from assets to liabilities",
    },
} satisfies Record<
    AccountClassMismatch["direction"],
    { imported: string; target: string; movement: string }
>;

export const AccountClassMismatchDescription = ({
    mismatch,
}: {
    mismatch: AccountClassMismatch;
}) => {
    const copy = CLASS_COPY[mismatch.direction];
    const targetTypeLabel = FINANCIAL_ACCOUNT_TYPE_LABEL[mismatch.targetType];

    return (
        <>
            {mismatch.importedAccountName} is {copy.imported} (
            {FINANCIAL_ACCOUNT_TYPE_LABEL[mismatch.importedType]}) in the
            migrated data but is being merged into{" "}
            {mismatch.targetAccountName ?? targetTypeLabel}, {copy.target} (
            {targetTypeLabel}). Balances will move {copy.movement}.
        </>
    );
};
